export const REWARDS_MODULE = {
    GENEROSITY_SWIMLANE: 'merch_swim_lane',
    PROMO_HUB_HOME: 'promo_hub_home',
    PROMO_HUB_OFFER: 'promo_hub_offer',
    REWARDS_HUB: 'rewards_hub',
    AVAILABLE_PROMOS: 'rewards_available_promos',
    COMPLETED_PROMOS: 'rewards_completed_promos',
    LEARN_MORE: 'rewards_learn_more',
    REWARDS_ACTIVE_CARDS: 'rewards_active_cards',
    MERCH_SWIM_LANE: 'merch_swim_lane',
    RB_ANIMATION: 'reward_box_animation',
    RB_ERROR_MODAL: 'reward_box_error_modal',
    REWARDS_MODULE: 'rewards_module',
    HERO_CAROUSEL: 'hero_carousel'
} as const;

export const REWARDS_SOURCE = {
    PROMO_HUB: 'promo_hub',
    CAROUSEL_MORE_INFO: 'carousel_more_info',
    DIRECT: 'direct'
} as const;

export const REWARDS_LINK_TYPE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    IMAGE: 'image'
} as const;

export const REWARDS_BOX_STATUS = {
    NONE: 'none',
    SINGLE: 'single',
    MULTIPLE: 'multiple',
    UNKNOWN: 'unknown'
} as const;

export const REWARDS_PAGE_NAME = 'rewards';
export const LOBBY_PAGE_NAME = 'home';

export const REWARD_TYPE = {
    DYNAMIC_BONUS: 'dynamic_bonus'
} as const;

export const REWARDS_DEFAULT_LINK_TEXT = {
    PRIMARY_CTA: 'primary_cta',
    SECONDARY_CTA: 'secondary_cta',
    OPT_IN: 'opt_in'
} as const;

export const REWARDS_HUB_AMP_EVENT = {
    REWARDS_MODULE_LINK_CLICKED: 'Rewards Module Link Clicked',
    REWARDS_MODULE_VIEWED: 'Rewards Module Viewed',
    REWARDS_MODULE_ERROR: 'Rewards Module Error',
    REWARDS_MODULE_REFRESHED: 'Rewards Module Refreshed',

    REWARDS_BOX_ERROR_CTA_CLICKED: 'Rewards Box Error CTA Clicked',
    REWARDS_BOX_ERROR: 'Rewards Box Error',
    REWARDS_BOX_ANIMATION_CLOSED: 'Rewards Box Animation Closed',
    REWARDS_BOX_OPENED: 'Rewards Box Opened',
    REWARDS_BOX_CAROUSEL_SCROLLED: 'Rewards Box Carousel Scrolled',

    ONBOARDING_ERROR: 'Rewards Hub Loyalty Onboarding Error',
    ONBOARDING_CTA_CLICKED: 'Rewards Hub Loyalty Onboarding CTA Clicked',
    ONBOARDING_VIEWED: 'Rewards Hub Loyalty Onboarding Viewed',

    PRIMARY_PERK_TOOLTIP_CLICKED: 'Rewards Perk Tooltip Opened',
    PRIMARY_PERK_CTA_CLICKED: 'Rewards Hub Primary Perk CTA Clicked',

    LOGGED_OUT_CASINO_BONUS_CLICKED: 'Rewards Hub Logged Out Casino Bonus Clicked',
    LOGGED_IN_CASINO_BONUS_CLICKED: 'Rewards Hub Logged In Casino Bonus Clicked',

    HOW_IT_WORKS_VIEWED: 'Rewards Hub How It Works Viewed',
    LOYALTY_PROGRESS_BAR_OPENED: 'Rewards Progress Bar Opened',

    PROMOTION_TAB_VIEWED: 'Rewards Promotion Tab Viewed',
    BONUS_SPINS_INFO_MODAL_VIEW_CLICKED: 'Rewards Hub Bonus Spins Info Modal View Clicked',
    BONUS_SPINS_MODULE_CLICKED: 'Rewards Hub Bonus Spins Module Clicked',
    BONUS_SPINS_MODAL_CTA_CLICKED: 'Rewards Hub Bonus Spins Modal CTA Clicked',

    REWARDS_PAGE_CONTENT_LOADED: 'Rewards Page Content Loaded',
    PROMO_OFFER_PAGE_VIEWED: 'Promo Offer Page Viewed',
    PROMO_OFFER_CTA_CLICKED: 'Promo Offer CTA Clicked',
    PROMO_OFFER_TERMS_EXPANDED: 'Promo Offer Terms Expanded',
    PROMO_HUB_CARDS_ALL_VIEWED: 'Promo Hub Cards All Viewed',
    PROMO_CARD_VIEWED: 'Promo Card Viewed',
    PROMO_CARD_CLICKED: 'Promo Card Clicked',
    PROMO_OPT_IN_SUBMITTED: 'Promo Opt In Submitted',
    PROMO_OPT_IN_SUCCESSFUL: 'Promo Opt In Successful',
    PROMO_OPT_IN_FAILED: 'Promo Opt In Failed',
    PROMO_GENERIC_ERROR: 'Rewards Hub Promo Generic Error',

    LEADERBOARD_FIND_MY_RANK_CLICKED: 'Rewards Hub Leaderboard Find My Rank Clicked',
    LOYALTY_DETAILS_FAQ_OPENED: 'Rewards Hub Loyalty Details FAQ Opened',

    REWARDS_ACTIVE_CARD_CTA_CLICKED: 'Rewards Active Card CTA Clicked',
    REWARDS_ACTIVE_CARD_EXPANDED: 'Rewards Active Card Expanded',
    REWARDS_ACTIVE_CARD_COLLAPSED: 'Rewards Active Card Collapsed',
    REWARDS_ACTIVE_ERROR_CTA_CLICKED: 'Rewards Active Error CTA Clicked',
    PROMO_PROGRESS_CARD_VIEWED: 'Promo Card Viewed',
    NAVIGATION_LINK_CLICKED: 'Navigation Link Clicked',
    REFER_WIDGET_VIEWED: 'RAF Banner Viewed',
    REFER_WIDGET_CLICKED: 'RAF Banner Clicked'
} as const;
